import Input from "../../Input"

const MultiRank = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full font-sans">
            <h6 className="flex justify-center">رنک تجمیعی</h6>
            <div className="">
                <Input
                    type="number"
                    label="ایدی رنک *"
                    name={`multiRank-rankId`}
                    placeholder="RankID"
                    options={serverData?.sgList}
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.rankId}
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="رنک هایی که وقتی رنک بالایی به کاربر اضافه میشود بقیه هم اضافه شوند"
                    name={`multiRank-multiRanks`}
                    options={serverData?.sgList}
                    multi={true}
                    placeholder="مثال: 1,2,3"
                    autoComplete="off"
                    defaultValue={values?.multiRanks}
                    dir="ltr"
                />
            </div>

            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>
                    هر موقع اون رنکی که در فیلد بالا وارد کردید به کاربر بدید رنک های فیلد پایین نیز به کاربر اضافه
                    میشود
                </span>
            </div>
        </div>
    )
}

export default MultiRank
